import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import AutoLoanModuleView from 'partial/OfferManager/modules/AutoLoanModuleRedesign/AutoLoanModuleView';
import {
  buildAutoLoanQueryObject,
  DEFAULT_LOAN_AMOUNT,
  PURCHASE_NEW,
} from 'helpers/autoLoan.helper';
import { completeAutoLoanFormForOffers } from 'actions/product.actions';
import { useEffect } from 'react';
import { useAutoMarketplace } from '../AutoLoanOffersMarketplaceModule/hooks/autoMarketplace.hook';

export const AutoLoanModuleController = props => {
  const { creditInfo, userInfo, dispatch } = props;

  useAutoMarketplace({
    creditInfo,
    userInfo,
    isPurchaseOffersRequired: true,
    autoLoanTab: {
      selectedTab: 'Purchase',
    },
  });

  const loading = props.globalLoadingFlag;
  useEffect(() => {
    if (creditInfo && userInfo) {
      let queryObject;
      queryObject = buildAutoLoanQueryObject(
        creditInfo,
        userInfo,
        {
          autoLoanPurpose: PURCHASE_NEW,
          loanAmount: DEFAULT_LOAN_AMOUNT,
        },
        false,
      );
      dispatch(
        completeAutoLoanFormForOffers({
          queryObject,
          autoLoanType: 'Purchase',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <LoadingMask />;
  } else {
    return <AutoLoanModuleView {...props} />;
  }
};
